/**
 * Dirección en una línea, igual que `CustomerAddress.GetFullAddress()` del backend: es la
 * que se guarda en la orden a domicilio. La usan la vista previa al capturarla y la caja
 * offline, que arma la orden sin servidor.
 */
export const formatAddress = (addr: {
  street?: string; exteriorNumber?: string; interiorNumber?: string;
  colony?: string; city?: string; postalCode?: string;
}): string => {
  const parts = [];
  if (addr.street) {
    let streetPart = addr.street;
    if (addr.exteriorNumber) streetPart += ` #${addr.exteriorNumber}`;
    if (addr.interiorNumber) streetPart += ` Int. ${addr.interiorNumber}`;
    parts.push(streetPart);
  }
  if (addr.colony) parts.push(`Col. ${addr.colony}`);
  if (addr.city) parts.push(addr.city);
  if (addr.postalCode) parts.push(`C.P. ${addr.postalCode}`);
  return parts.join(', ');
};
